import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <a href="https://api.whatsapp.com/send?phone=972529566211" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:bg-[#20bd5a] transition-colors flex items-center justify-center group" aria-label="Chat on WhatsApp" data-id="element-172">
      <MessageCircle className="h-8 w-8" data-id="element-173" />
      <span className="absolute right-full mr-3 bg-white text-[#1f2933] px-3 py-1 rounded shadow-md text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap hidden md:block" data-id="element-174">
        Chat with us
      </span>
    </a>;
}